import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function FAQPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const response = await fetch(`${API_URL}/api/faq`);
      if (response.ok) {
        setItems(await response.json());
      }
    } catch (error) {
      console.error('Error fetching FAQ:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-2 border-foreground/20 border-t-brand rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground text-sm uppercase tracking-wider">Lädt</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <section className="pt-32 pb-20 md:pt-40 md:pb-32">
        <div className="container-custom max-w-4xl">
          <Reveal>
            <span className="kicker mb-6 inline-flex">Know the terms / Own the call</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-display text-5xl md:text-7xl text-foreground mb-6">
              FAQ
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-foreground/80 text-lg leading-relaxed mb-12 max-w-2xl">
              Antworten zu Verträgen, Monatsbetreuung, Produktion und den
              wichtigsten Kundenfragen, klar und verständlich.
            </p>
          </Reveal>

          <Reveal delay={0.3}>
            <Accordion type="single" collapsible className="w-full">
              {items.map((item, index) => (
                <AccordionItem
                  key={item.id}
                  value={item.id}
                  className="border-b border-border"
                >
                  <AccordionTrigger className="text-left gap-6 py-5 hover:no-underline group">
                    <span className="flex items-baseline gap-4">
                      <span className="font-display text-brand/40 text-lg shrink-0 group-hover:text-brand transition-colors">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="font-body font-semibold text-base md:text-lg text-foreground">
                        {item.question}
                      </span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base leading-relaxed pl-12 pb-6">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          {items.length === 0 && (
            <p className="text-muted-foreground text-center py-16">
              Noch keine FAQ-Einträge vorhanden.
            </p>
          )}

          <Reveal delay={0.2}>
            <div className="mt-16 bg-ink text-white p-8 md:p-10 border-b-4 border-yellow flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <h2 className="font-display text-2xl mb-2">Frage nicht dabei?</h2>
                <p className="text-white/70 text-sm">
                  Schreib uns, wir antworten innerhalb von 24 Stunden.
                </p>
              </div>
              <Link to="/#contact" className="btn-primary shrink-0">
                Kontakt aufnehmen →
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
